import { render, staticRenderFns } from "./BankStatementDetails.vue?vue&type=template&id=7d89c3c0"
import script from "./BankStatementDetails.vue?vue&type=script&lang=js"
export * from "./BankStatementDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports